import api from '@/api';
import moment from 'moment';

const state = {
  projectsTasks: [],
  usersVelocity: [],
  loadedProject: null,
  loadedUser: null,
};

const getters = {
  projectTasks: state => state.projectsTasks
    .find(project => project.projectName === state.loadedProject),
};

const actions = {
  async getListByProject({ state, commit, rootGetters }, payload) {
    if (state.loadedUser === payload.user && state.projectsTasks.length > 0) {
      return;
    }

    commit('projectsTasks', []);
    commit('loadedUser', payload.user);
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('WorkItems/List', {
      Member: user,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });
    commit('projectsTasks', response.data.projectTasks);
  },

  async exportToExcel({ state, rootGetters }) {
    const user = rootGetters['users/getUserById'](state.loadedUser);
    const response = await api.post('Reports/ExportVelocityReportToExcel', {
      projectTasks: state.projectsTasks,
      name: state.loadedUser,
    }, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Velocity_${user.user.displayName}_${moment().format('YYYY-MM-DD')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async getAllVelocity({ commit, rootState }, payload) {
    const response = await api.post('WorkItems/All', {
      StartDate: payload.startDate,
      EndDate: payload.endDate,
      Users: rootState.users.users,
    });

    commit('usersVelocity', response.data);
  },
};

const mutations = {
  projectsTasks(state, payload) {
    state.projectsTasks = payload;
  },
  usersVelocity(state, payload) {
    state.usersVelocity = payload;
  },
  loadedUser(state, payload) {
    state.loadedUser = payload;
  },
  loadedProject(state, payload) {
    state.loadedProject = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
